﻿import { LiveDataSet } from "../../API/LiveData/LiveDataSet";
import { ILiveDataListener } from "../../ILiveDataListener";
import { InfluxDataWrapper } from "../../InfluxDb/InfluxDataWrapper";
import { getHistoricData } from "../../InfluxDb/InfluxDb";
import { MainSite } from "../../MainSite";
import { ParameterGroupInfoSet } from "../../ParameterGroupInfoSet";
import { ISiteObservationsPageWindTab } from "./ISiteObservationsPage";

export class WindChart implements ILiveDataListener {

    private chartContainer: JQuery;
    private chart: __Highcharts.ChartObject;
    private stationId: string;
    private timeZoneString: string;

    private sensorIds: string[];

    constructor(private mainSite: MainSite, private page: ISiteObservationsPageWindTab, sensorIds: string[], container: JQuery, top: number, left: number, height: number, width: number) {

        this.stationId = page.station.Station.Id;
        this.sensorIds = sensorIds;

        var box: JQuery = $('<div class="midi_SiteObservations_chart_container"></div>')
            .css('position', 'absolute')
            .css('top', top + '%')
            .css('left', left + '%')
            .css('height', height + '%')
            .css('width', width + '%');

        container.append(box);

        this.chartContainer = $('<div></div>')
            .css('height', '100%')
            .appendTo(box);

        this.timeZoneString = this.mainSite.getTimeZoneString();


        this.drawChart();
        this.updateChart(MainSite.instance.liveDataManager.latestData);

    }

    public liveDataChanged(latestData: LiveDataSet): void {
        this.updateChart(latestData);
    }

    private drawChart(): void {

        var yAxisOptions = [];

        yAxisOptions.push(
            {
                title: {
                    text: 'Speed (kts)'
                },
                min: 0,
                lineColor: '#666',
                //lineWidth: 1,
                gridLineColor: '#666',
                gridLineWidth: 0.5,
                gridLineDashStyle: 'solid'
            },
            {
                title: {
                    text: 'Direction (°T)'
                },
                min: 0,
                max: 360,
                opposite: true,
                lineColor: '#666',
                //lineWidth: 1,
                gridLineColor: '#666',
                gridLineWidth: 0.5,
                gridLineDashStyle: 'longdash',
                tickInterval: 90,
                minTickInterval: 90,
                alignTicks: false
            });


        this.chartContainer.highcharts(<any>{
            chart: {
                type: 'line',
                backgroundColor: '#FFF',
                marginTop: 30
            },
            exporting: {
                enabled: false
            },
            title: {
                text: ''
            },
            xAxis: {
                type: 'datetime',
                ordinal: false,
                lineWidth: 0,
                lineColor: '#666'
            },
            yAxis: yAxisOptions,
            legend: {
                enabled: true
            },
            plotOptions: {
                series: {
                    animation: false,
                    events: {
                        legendItemClick: function () {
                            return false;
                        }
                    }
                }
            },
            credits: {
                enabled: false
            },
            tooltip: {
                xDateFormat: '%Y-%m-%d %H:%M:%S ' + this.timeZoneString,
                valueDecimals: 0
            }
        });

        this.chart = this.chartContainer.highcharts();
        this.chart.showLoading('Getting data...');
    }

    private static getSeriesColor(index: number, lighten: boolean = false): string {

        // only need to support four

        switch (index) {
            case 0:
                if (lighten) {
                    return 'rgba(255, 60, 60, 0.8)';
                }
                return 'rgba(255, 0, 0, 0.8)';
            case 1:
                if (lighten) {
                    return 'rgba(40, 60, 255, 0.8)';
                }
                return 'rgba(0, 0, 255, 0.8)';
            case 2:
                if (lighten) {
                    return 'rgba(60, 255, 60, 0.8)';
                }
                return 'rgba(0, 255, 0, 0.8)';
            default:
                if (lighten) {
                    return 'rgba(127, 60, 255, 0.8)';
                }
                return 'rgba(127, 0, 255, 0.8)';
        }

    }

    private updateChart(latestData: LiveDataSet): void {

        if (!latestData) return;

        var seriesOptions: { [sensorId: string]: __Highcharts.SeriesOptions[] } = {};

        var toMoment = moment.utc();
        var fromMoment = moment.utc().subtract(3, 'h'); // 2 hours ago

        var anyData = false;

        var maxParamCount = 3 * this.sensorIds.length;
        var accountedParamCount = 0;

        this.sensorIds.forEach((sensorId, index) => {

            seriesOptions[sensorId] = [];

            // find the correct parameter for this sensor ID
            var windSpeedParam = null;
            ///[ParameterGroupInfoSet.WindSpeed_kts_10min.Id, ParameterGroupInfoSet.WindSpeed_kts_1min.Id].some(id => {
            [this.page.windSpeedGroup10min.Id, this.page.windSpeedGroup1min.Id].some(id => {
                if (latestData.Stations[this.stationId].GroupValues[id]) {
                    latestData.Stations[this.stationId].GroupValues[id].some(value => {
                        if (value.Sensor == sensorId) {
                            windSpeedParam = value.Parameter;
                            return true;
                        }
                        return false;
                    });

                    return true;
                }
            });


            var gustSpeedParam = null;
            ///[ParameterGroupInfoSet.GustSpeed_kts_10min.Id, ParameterGroupInfoSet.GustSpeed_kts_1min.Id].some(id => {
            [this.page.gustSpeedGroup10min.Id, this.page.gustSpeedGroup1min.Id].some(id => {
                if (latestData.Stations[this.stationId].GroupValues[id]) {
                    latestData.Stations[this.stationId].GroupValues[id].some(value => {
                        if (value.Sensor == sensorId) {
                            gustSpeedParam = value.Parameter;
                            return true;
                        }
                        return false;
                    });

                    return true;
                }
            });

            var windDirParam = null;
            [ParameterGroupInfoSet.WindDirection_deg_10min.Id, ParameterGroupInfoSet.WindDirection_deg_1min.Id].some(id => {
                if (latestData.Stations[this.stationId].GroupValues[id]) {
                    latestData.Stations[this.stationId].GroupValues[id].some(value => {
                        if (value.Sensor == sensorId) {
                            windDirParam = value.Parameter;
                            return true;
                        }
                        return false;
                    });

                    return true;
                }
            });

            if (windSpeedParam) {
                getHistoricData(
                    'P',  // Assume data will be coming from RDS for now
                    this.stationId, sensorId, windSpeedParam, null, fromMoment.valueOf(), toMoment.valueOf(), (err: any, data: InfluxDataWrapper) => {
                    if (err) {
                        console.warn('Wind Chart - Error getting data: ', err);
                        this.chart.showLoading('Error getting data...');
                        return;
                    }

                    anyData = anyData || data.Data !== null;

                    if (data.Data !== null) {

                        data.Data.unshift([fromMoment.valueOf(), null]);
                        data.Data.push([toMoment.valueOf(), null]);
                    }


                    seriesOptions[sensorId].push({
                        ///id: ParameterGroupInfoSet.WindSpeed_kts.Id,
                        id: this.page.windSpeedGroup.Id,
                        color: WindChart.getSeriesColor(index, true),
                        name: "Speed (kts) - " + sensorId,
                        data: data.Data,
                        dashStyle: 'dot',
                        zIndex: (index == 0) ? 2 : 1,
                        lineWidth: 1,
                        marker: {
                            enabled: false
                        },
                        yAxis: 0
                    })

                    accountedParamCount++;

                    if (accountedParamCount == maxParamCount) {
                        if (anyData) {
                            this.replaceChartSeries(seriesOptions);
                        } else {
                            this.chart.showLoading('Data not available');
                        }
                    }
                }, 0);
            } else {
                accountedParamCount++;
            }

            if (gustSpeedParam) {
                getHistoricData(
                    'P',  // Assume data will be coming from RDS for now
                    this.stationId, sensorId, gustSpeedParam, null, fromMoment.valueOf(), toMoment.valueOf(), (err: any, data: InfluxDataWrapper) => {
                    if (err) {
                        console.warn('Wind Chart - Error getting data: ', err);
                        this.chart.showLoading('Error getting data...');
                        return;
                    }

                    anyData = anyData || data.Data !== null;

                    if (data.Data !== null) {

                        data.Data.unshift([fromMoment.valueOf(), null]);
                        data.Data.push([toMoment.valueOf(), null]);
                    }


                    seriesOptions[sensorId].push({
                        ///id: ParameterGroupInfoSet.GustSpeed_kts.Id,
                        id: this.page.gustSpeedGroup.Id,
                        color: WindChart.getSeriesColor(index),
                        name: "Gust (kts) - " + sensorId,
                        data: data.Data,
                        zIndex: (index == 0) ? 2 : 1,
                        lineWidth: 1,
                        marker: {
                            enabled: false
                        },
                        yAxis: 0
                    })

                    accountedParamCount++;

                    if (accountedParamCount == maxParamCount) {
                        if (anyData) {
                            this.replaceChartSeries(seriesOptions);
                        } else {
                            this.chart.showLoading('Data not available');
                        }
                    }
                }, 0);
            } else {
                accountedParamCount++;
            }

            if (windDirParam) {
                getHistoricData(
                    'P',  // Assume data will be coming from RDS for now
                    this.stationId, sensorId, windDirParam, null, fromMoment.valueOf(), toMoment.valueOf(), (err: any, data: InfluxDataWrapper) => {
                    if (err) {
                        console.warn('Wind Chart - Error getting data: ', err);
                        this.chart.showLoading('Error getting data...');
                        return;
                    }

                    anyData = anyData || data.Data !== null;

                    if (data.Data !== null) {

                        data.Data.unshift([fromMoment.valueOf(), null]);
                        data.Data.push([toMoment.valueOf(), null]);
                    }


                    seriesOptions[sensorId].push({
                        id: ParameterGroupInfoSet.WindDirection_deg.Id,
                        color: WindChart.getSeriesColor(index),
                        name: "Dir (kts) - " + sensorId,
                        data: data.Data,
                        lineWidth: 0,
                        zIndex: (index == 0) ? 2 : 1,
                        marker: {
                            enabled: true,
                            radius: 2,
                            symbol: 'diamond'
                        },
                        yAxis: 1
                    })

                    accountedParamCount++;

                    if (accountedParamCount == maxParamCount) {
                        if (anyData) {
                            this.replaceChartSeries(seriesOptions);
                        } else {
                            this.chart.showLoading('Data not available');
                        }
                    }
                }, 0);
            } else {
                accountedParamCount++;
            }
        });
    }

    private replaceChartSeries(seriesOptions: { [sensorId: string]: __Highcharts.SeriesOptions[] }) {
        this.chart.hideLoading();
        if (this.chart.series.length < 1) {
            for (var sensorId in seriesOptions) {
                seriesOptions[sensorId].forEach((series) => {
                    this.chart.addSeries(series);
                });
            }
        } else {
            for (var sensorId in seriesOptions) {
                seriesOptions[sensorId].forEach((series) => {
                    var cs: __Highcharts.SeriesObject  = <__Highcharts.SeriesObject>this.chart.get(series.id);
                    cs.setData(<any>series.data);
                });
            }
        }

        this.chart.reflow();
    }
}